import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetSimXAgreementRequest } from '../models/requests/get-simx-agreement-request.model';
import { GetSimXAgreementsRequest } from '../models/requests/get-simx-agreements-request.model';
import { GetSimXAgreementResponse } from '../models/responses/get-simx-agreement-response.model';
import { GetSimXAgreementsResponse } from '../models/responses/get-simx-agreements-response.model';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class AgreementDataService {
  private readonly _dataService = inject(DataService);
  private readonly _http = inject(HttpClient);

  getAgreements(
    request: GetSimXAgreementsRequest = {},
  ): Observable<GetSimXAgreementsResponse> {
    const url = this._dataService.agreementsUrl();
    return this._http.post<GetSimXAgreementsResponse>(url, request);
  }

  getAgreement(
    agreementId: string,
    request: GetSimXAgreementRequest = {},
  ): Observable<GetSimXAgreementResponse> {
    const url = this._dataService.agreementsUrl(agreementId);
    return this._http.post<GetSimXAgreementResponse>(url, request);
  }

  getRequiredAndUnsignedAgreementsForUser(
    userId: string,
    request: GetSimXAgreementsRequest = {},
  ): Observable<GetSimXAgreementsResponse> {
    const url = this._dataService.agreementsUnsignedForUserUrl(userId);
    return this._http.post<GetSimXAgreementsResponse>(url, request);
  }
}
